import { memo, useState } from 'react';
import classes from 'classnames';
import copy from 'copy-to-clipboard';
import Button from '../Button/Button';
import styles from './CopyValue.module.scss';

export type Props = {
  label: string;
  value: string;
  copyLabel: string;
  confirmLabel?: string;
  className?: string;
  dataTest?: string;
};

export default memo(function CopyValue({
  label,
  value,
  copyLabel,
  confirmLabel,
  className,
  dataTest,
}: Props) {
  const [confirmed, setConfirmed] = useState(false);
  const handleClick = () => {
    try {
      copy(value);
      // display a confirmation message for 2 seconds
      setConfirmed(true);
      setTimeout(() => {
        setConfirmed(false);
      }, 2000);
    } catch {}
  };
  return (
    <div className={classes(styles.wrapper, className)} data-test={dataTest}>
      <div className={styles.info}>
        <div className={styles.label}>{label}</div>
        <div className={styles.value}>{value}</div>
      </div>
      <div className={styles['confirm-wrapper']}>
        {confirmLabel && confirmed && (
          <div className={styles.confirm}>{confirmLabel}</div>
        )}
      </div>
      <Button className={styles.button} outline size="s" onClick={handleClick}>
        {copyLabel}
      </Button>
    </div>
  );
});
